const searchStrip = {
  hotels: "Hotel", // translated 
  city: "Bandar", // translated 
  checkIn: "Daftar Masuk", // translated 
  checkOut: "Daftar Keluar", // translated 
  date: "Tarikh", // translated 
  persons: "Orang", // translated 
  adults: "Dewasa", // translated 
  rooms: "Bilik-bilik", // translated 
  editSearch: "Edit Carian", // translated 
  newSearch: "Carian Baharu", // translated 
  listView: "Paparan Senarai", // translated 
  mapView: "Paparan Peta", // translated 
};





export default searchStrip;
